module.exports = __webpack_public_path__ + "static/zikto_profile@3x-b698e34db988f62ebb7d9ff234c06695.png";